import {
  Directive, ElementRef, HostListener, AfterViewInit, OnChanges,
  SimpleChanges, Input, HostBinding
} from '@angular/core';

@Directive({
    selector: 'textarea[autoResize]',
    standalone: false
})
export class AutoResizeTextareaDirective implements AfterViewInit, OnChanges {
  @Input() ngModel: any;

  @HostBinding('class.auto-resize-textarea') autoResizeClass = true;

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit() {
    setTimeout(() => this.adjustTextareaHeight(), 10);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ngModel']) {
      setTimeout(() => this.adjustTextareaHeight(), 10);
    }
  }

  @HostListener('input')
  onInput() {
    this.adjustTextareaHeight();
  }

  @HostListener('window:resize')
  onResize() {
    this.adjustTextareaHeight();
  }

  private adjustTextareaHeight() {
    const textarea: HTMLTextAreaElement = this.elementRef.nativeElement;
    if (!textarea) return;

    textarea.style.height = 'auto';
    const newHeight = textarea.scrollHeight + 2;
    textarea.style.height = `${newHeight}px`;
  }
}